export enum DeviceTypeEnum {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
  HEADLESS = 'headless',
}
